<template>
  <div :class="['bear-actions', {'show-tips': showTips}]">
    <div v-if="withZhcgActions" class="bear-actions-banner" @click="preJump">
      <img src="./img/dzcg.png" alt="综合采购">
    </div>
    <div class="bear-actions-flex">
      <div class="bear-actions-left">
        <slot name="prepend"></slot>
        <component v-if="actionSetting.prepend" :is="actionSetting.prepend" />
        <el-button v-for="(obj, i) in actions" :key="i" v-show="obj.actionId !== 'general-purchase_jump'" type="primary" class="bear-actions-button" @click="action(obj)" :disabeld="!obj.available">{{
          obj.actionName
        }}</el-button>
        <!-- <el-button v-if="!isEdit && !isPublic" type="primary" onclick="window.print()">打印</el-button> -->
        <slot name="append"></slot>
        <component v-if="actionSetting.append" :is="actionSetting.append" />
        <div v-if="showTips && flag === 'true'" class="bear-actions-login">
          请<el-button type="primary" @click="jumpToLogin" class="bear-actions-button">登录</el-button> {{ plateFormName }}选择<span class="red">"{{ category }}"</span>进行投标
        </div>
      </div>
      <!-- 已取消 <div v-if="isZZZB" class="bear-actions-center">
        <el-button type="primary" class="bear-actions-button" @click="reportProvince">上报省平台</el-button>
      </div> -->
      <div v-if="(!isEdit && (!showTips || name === 'LogOn_GUOZI' || isGEC))" class="bear-actions-right">
        <el-button type="primary" class="bear-actions-button" onclick="window.print()">打印</el-button>
      </div>
    </div>
    <el-row v-if="showTips && name !== 'LogOn_GUOZI' && !isGEC">
      <el-col :span="22" class="bear-actions-tips">
        重要提示：该招标项目后续发布的补充、答疑等公告，投标人须关注“随行软件”公众号后通过“易中标”小程序的关注功能进行查看，避免遗漏。
      </el-col>
      <el-col :span="2" class="text-center">
        <el-button type="primary" onclick="window.print()">打印</el-button>
      </el-col>
    </el-row>
    <div v-if="checkedModify && checkedMessage" class="bear-actions-error">
      {{ checkedMessage }}
    </div>
    <el-dialog v-model="dlgRecordsVisible" title="操作记录" top="5vh" width="900px">
      <el-table :data="records" header-cell-class-name="records-header-cell" max-height="580px" border stripe>
        <el-table-column prop="UserInfo.UnitName" label="单位/企业" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="UserInfo.UserName" label="操作者" width="100" align="center"></el-table-column>
        <el-table-column prop="Record" label="流程操作" width="180" align="center"></el-table-column>
        <el-table-column label="内容" width="100" align="center">
          <template #default="scope">
            <el-link v-if="scope.row.SignUrl" type="primary" :href="scope.row.SignUrl">签章</el-link>
          </template>
        </el-table-column>
        <el-table-column label="下载" width="100" align="center">
          <template #default="scope">
            <el-link v-if="scope.row.SignDnUrl" type="primary" :href="scope.row.SignDnUrl">下载</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="RecordTime" label="时间" width="160" align="center"></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog v-model="dlgFormVisible" :title="formTitle" width="600px">
      <el-form :model="formData" :rules="fules" ref="formData" label-width="labelWidth">
        <template v-for="(item, i) in formTemplate" :key="i">
          <p v-if="item.type === 'p'">{{ item.label }}</p>
          <el-form-item v-else :label="item.label" :prop="item.key">
            <el-input v-if="item.type === 'text'" type="text" v-model="formData[item.key]"></el-input>
            <el-input v-else-if="item.type === 'textarea'" type="textarea" v-model="formData[item.key]"></el-input>
            <el-date-picker v-else-if="item.type === 'date'" type="date" v-model="formData[item.key]"></el-date-picker>
          </el-form-item>
        </template>
      </el-form>
      <template #footer>
        <el-button type="default" @click="dlgFormVisible = false">取消</el-button>
        <el-button type="primary" @click="flowFormPost('formData')">确定</el-button>
      </template>
    </el-dialog>
    <el-dialog v-model="dlgFrameVisible" :title="formTitle" custom-class="dlg-model" top="5vh" width="90%" @close="closeFrameModel" draggable>
      <div class="dlg-model-content">
        <iframe class="iframe-model" :src="formPage" frameborder="0"></iframe>
      </div>
    </el-dialog>
    <bear-sign :options="signUrlOptions"></bear-sign>
  </div>
</template>
<script>
import { h } from "vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import BearSign from "../../sign/src";
import api from '@/common/js/api'
import { TenderCheckedUtils } from "@/common/tender/house/utils";
import { getUrlParams } from "@/common/js/utils";
export default {
  name: "BearActions",
  components: {
    BearSign,
  },
  computed: {
    ...mapState(["isEdit", "isView", "actions", "records", "actionSetting", "form", "signUrlOptions", "isPublic", "category"]),
    ...mapState('houseStore', ["isEnableGeneralPurchaseJump"]),
    plateFormName() {
      let { regionId } = this.form;
      let { name, flag } = this.params;
      if (name === "LogOn_GUOZI") return "福建省国资采购平台";
      if (name === "logOn_XIAMENAIR" || regionId === "x50002") return "厦门航空电子交易平台";
      if (name === "logOn_Phone_Gong") return "公E采电子招标投标平台";
      return "随行易交易电子招标投标平台";
    },
    flag() {
      return this.params.flag
    },
    showTips () {
      return location.pathname.slice(-14) === 'entp-view.html' && this.flag
    },
    name() {
      return this.params.name
    },
    isZZZB() {
      const { regionId, REGION_CODE, IS_REPORT_PROVINCE_OUTSIDE } = this.form
      if(location.pathname.slice(-10) !== '/view.html') return false
      if(/(\d{6}|x20001|x40002)/.test(regionId)) {
        return false
      } else  {
        return /^35/.test(REGION_CODE) && IS_REPORT_PROVINCE_OUTSIDE === undefined
      }
    },
    isGEC() {
      return this.params.name === 'logOn_Phone_Gong'
    },
    zhcgActions() {
      return this.actions.find(obj => obj.actionId === 'general-purchase_jump')
    },
    withZhcgActions() {
      const { isEnableGeneralPurchaseJump, zhcgActions } = this
      return isEnableGeneralPurchaseJump || (zhcgActions && zhcgActions.available)
      // return this.zhcgActions && this.zhcgActions.available
    }
  },
  data() {
    return {
      params: {},
      tenderChecked: TenderCheckedUtils.state,
      checkedModify: false,
      checkedMessage: "",
      curAction: null,
      formSign: false,
      formTitle: "",
      formPage: "about:blank",
      formTemplate: [],
      formData: {},
      rules: [],
      labelWidth: "80px",
      dlgRecordsVisible: false,
      dlgFormVisible: false,
      dlgFrameVisible: false,
      reportServer: ''
    };
  },
  mounted() {
    this.params = getUrlParams(window.top.location.search);
    TenderCheckedUtils.$vm = this;
  },
  methods: {
    action(obj) {
      let { formData, commit, sign } = this.actionSetting;
      let {
        available,
        actionName,
        actionContent: { openPage, pageUrl, type, formTemplate, Msg },
      } = obj;
      if (available) {
        if (type === "view") {
          window.open(pageUrl);
        } else if (type === "model") {
          this.formTitle = "";
          this.formPage = pageUrl;
          this.dlgFrameVisible = true;
        } else if (type === "history") {
          this.getRecords(obj);
        } else if (type === "form") {
          if (formData) {
            this.doAction(obj);
          } else {
            this.flowForm(obj);
          }
        } else if (type === "commit") {
          if (commit) {
            this.doAction(obj);
          } else {
            this.flowCommit(obj);
          }
        } else if (type === "sign") {
          if (formTemplate) {
            this.flowForm(obj, true);
          } else {
            if (sign) {
              this.doAction(obj);
            } else {
              this.flowSign(obj);
            }
          }
        } else {
          this.doAction(obj);
        }
      } else {
        this.$alert(h("p", {
          style: "color: red; font-size: 18px",
        }, Msg),
        `${actionName}按钮不可用提示`,{
          type: "warning",
          confirmButtonText: "我已了解",
        });
      }
    },
    flowCommit(obj) {
      let { actionContent, actionName } = obj;
      let { url } = actionContent;
      let data = JSON.stringify(this.formData);
      this.doPost({ url, data }).then((res) => {
        if (res.result) {
          location.reload();
        } else {
          this.$message.info(res.msg || `${actionName}失败`);
        }
      }).catch((e) => {
        this.$message.error(`service ${actionName}失败`);
      });
    },
    flowSign(obj, data) {
      let { actionContent, actionName } = obj;
      let { url } = actionContent;
      this.doPost({ url, data }).then((res) => {
        if (res.result) {
          this.setSignUrlOptions(res);
        } else {
          this.$message.info(res.msg || `${actionName}失败`);
        }
      });
    },
    flowForm(obj) {
      let { actionContent, actionName } = obj;
      let form = {};
      let rules = {};
      let tips = [];

      this.curAction = obj;
      this.formSign = actionContent.type === "sign";
      this.formTitle = actionName;
      this.formTemplate = JSON.parse(actionContent.formTemplate);

      this.formTemplate.forEach((tpl) => {
        if (tpl.type === "p") {
          tips.push(tpl.label);
        } else {
          let type = "string";
          let trigger = "blur";
          if (tpl.type === "date") {
            type = "date";
            trigger = "change";
          }
          form[tpl.key] = "";
          rules[tpl.key] = [{ type, trigger, required: true, message: "不能为空" }];
        }
      });

      if (tips.length) {
        this.flowFormMessage(tips, actionContent.url);
      } else {
        this.rules = rules;
        this.form = form;
        this.dlgFormVisible = true;
      }
    },
    flowFormMessage(tips, url) {
      let { curAction } = this;
      let { formData, commit, sign } = this.actionSetting;
      this.$confirm(tips.join("，"), "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        switch (curAction.actionContent.type) {
          case "form":
            if (formData) return this.doAction(curAction);
          case "sign":
            if (sign) return this.doAction(curAction);
          case "commit":
            if (commit) return this.doAction(curAction);
        }

        this.doPost({ url }).then((res) => {
          if (this.formSign && res.result) {
            this.setSignUrlOptions(res);
          } else {
            // 错误说明
          }
        }).catch(() => null);
      }).catch(() => null);
    },
    flowFormPost(formName) {
      let { curAction } = this;
      let { url } = curAction.actionContent;
      let data = JSON.stringify(this.form);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formSign) {
            this.flowSign(this.curAction, { data });
          } else {
            let data = this[formName];
            this.doPost({ url, data }).then((res) => {
              if (res.result) {
                if (this.formSign) {
                  this.setSignUrlOptions(res);
                } else {
                  location.reload();
                }
              } else {
                // 错误说明
              }
            }).catch(() => {});
          }
        } else {
        }
      });
    },
    getRecords(obj) {
      this.requestRecords(obj).then((records) => {
        this.setRecords(records);
        this.dlgRecordsVisible = true;
      });
    },
    closeFrameModel() {
      location.reload();
    },
    reportProvince() {
      this.getReportServer((url) => {
        window.open(`${url}Home/index/${this.params.foId}?plan=zj`, '_blank')
      })
    },
    getReportServer(call) {
      if(this.reportServer) {
        call(this.reportServer)
      } else {
        api.get(`/static/config/serverConfig.json?t=${Date.now()}`).then(res => {
          if(res) {
            this.reportServer = res.reportServer
            call(this.reportServer)
          }
        })
      }
    },
    preJump () {
      const foId = this.params.foId || this.params.tpId
      if (this.isPublic) {
        window.open(`/TenderProject/Jump?url=/Account/preJump?foId=${foId}`, '_blank')
        // window.open(`/TenderProject/Jump?url=/views/ebid/combine/v1/entp-view.html?flowId=${this.form.flowId}%26tpId=${foId}%26type=tp`, '_blank')
      } else {
        window.open(`/Account/preJump?foId=${foId}`, '_blank')
      }
    },
    ...mapMutations(["setRecords", "setSignUrlOptions"]),
    ...mapActions(["doAction", "requestRecords", "doPost", "jumpToLogin"]),
  },
};
</script>
<style lang="scss" scoped>
.bear-actions {
  padding: 5px;
  &-banner {
    padding-top: 4px;
    text-align: center;
    background: #e3eefd;
    cursor: pointer;
    // img {
    //   border: 1px solid #4DA4FF;
    // }
  }
  &-flex {
    display: flex;
  }
  &-left {
    flex: 1;
  }
  &-right {
    text-align: center;
  }
  &-button {
    margin: 5px;
  }
  &-error {
    color: red;
    background: #ffedc8;
    font-size: 15px;
    padding: 5px 15px;
  }
  &-login {
    display: inline-block;
    font: bold 18px/30px microsoft yahei;
  }
  &-tips {
    padding: 0 10px;
    font: bold 16px/25px microsoft yahei;
    color: red;
  }
  .red {
    color: red
  }
}
</style>
<style lang="scss">
.records-header-cell {
  color: #666;
  background-color: #eef1f6 !important;
}
.dlg-model-content {
  overflow: auto;
}
.iframe-model {
  width: 100%;
  min-width: 1000px;
  height: calc(90vh - 135px);
}
.show-tips {
  .el-button {
    padding: 8px 10px;
  }
}
</style>
